import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9ec74e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "personal-job-modal-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Title", -1))
const _hoisted_13 = { class: "col-md-8 pr-0" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Date", -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Inspector", -1))
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Copy to", -1))
const _hoisted_22 = {
  key: 0,
  class: "col-md-1 col-form-label"
}
const _hoisted_23 = {
  key: 1,
  class: "col-sm-2",
  style: {"margin-top":"5px"}
}
const _hoisted_24 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Timing", -1))
const _hoisted_26 = { class: "col-md-4 pr-0" }
const _hoisted_27 = { class: "col-md-4 pl-0" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "All day", -1))
const _hoisted_30 = {
  class: "col-md-6",
  style: {"margin-top":"5px"}
}
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Location", -1))
const _hoisted_33 = { class: "col-md-8 pr-0" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "form-group row"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Description", -1))
const _hoisted_37 = { class: "col-md-8 pr-0" }
const _hoisted_38 = { class: "form-group row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Repeat", -1))
const _hoisted_40 = { class: "col-md-8 pr-0" }
const _hoisted_41 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_42 = { class: "form-group row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "Repeat every", -1))
const _hoisted_44 = { class: "col-md-9 pr-0" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "Repeat on", -1))
const _hoisted_50 = { class: "col-md-9 pr-0" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "form-group row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "Ends", -1))
const _hoisted_54 = { class: "col-md-9" }
const _hoisted_55 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "On", -1))
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = {
  key: 1,
  class: "form-group row"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-3 col-form-label" }, "After", -1))
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "modal-footer" }
const _hoisted_62 = ["disabled"]

import $ from 'jquery';
import { RRule, RRuleSet, rrulestr } from 'rrule'
import { ref, computed, onMounted, inject, watch, nextTick, PropType } from 'vue';
import { useStore } from 'vuex';
import moment from "moment-timezone";
import { DxDateBox } from "devextreme-vue/date-box";
import TiptapEditor from "@/components/editor/TiptapEditor.vue";
import { Booking, Inspector } from "@/models";
import { bookingdateformat } from "@/utilities";
import { useToast } from "vue-toastification";
import { emitEvent } from '@/eventBus';
import { DxSwitch } from 'devextreme-vue/switch';
import RecursionConfirmModal from "@/components/modals/RecursionConfirmModal";
// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalJobModal',
  props: {
  booking: { type: Object as PropType<Booking> },
  id: String
},
  emits: ['hide'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
// Vuex store
const store = useStore();

const inspectorlist = computed(() => store.getters['diary/inspectorlist']);
const _currentdate = computed(() => store.getters['diary/currentdate']);

// Reactive data
const recursionConfirmModal = ref(null);
const operation = ref("");
const personalbooking = ref(new Booking());
const bookingcopy = ref(new Booking());
const selectedinspector = ref(new Inspector());
const subjobdate = ref(new Date());
const inspectorinstringsearchfilter = ref('');
const copytoinspectorinstringsearchfilter = ref('');
const isSaving = ref(false);
const selectedinspectors = ref<Inspector[]>([]);

const repeatevery = ref(1);
const repeatfrequency = ref('week');
//https://trello.com/c/Ft26Xyjv/566-new-note-repeat-event-wording
const selectedfrequency = computed({
  set: (val: string) => {
    repeatfrequency.value = val.replaceAll('s', '');
  },
  get: () => {
    if (repeatevery.value > 1) {
      return `${repeatfrequency.value}s`;
    }
    else {
      return repeatfrequency.value;
    }
  }
})
//https://trello.com/c/Ft26Xyjv/566-new-note-repeat-event-wording
const repeatfrequencyoptions = computed(() => {
  var opts = ['day', 'week', 'month', 'year'];
  if (repeatevery.value > 1)
    opts = ['days', 'weeks', 'months', 'years'];
  return opts;
});
const repeaton = ref([false, false, false, false, false, false, false]);
const repeatonoptions = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
const ends = ref('Never');
const endsonoptions = ['Never', 'On', 'After'];
const threemonthsinfuture = moment().add(3, 'month').endOf('day').toDate();
const endson = ref(threemonthsinfuture);
const endsafteroccurancenumber = ref(13);
const allday = ref(false);
const sharewithall = ref(false);


const dynamicRefs = ref({});

// Injected property
const realtime: any = inject('realtime');
const actProperty: any = inject('actProperty');
const toasted = useToast();

const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const emit = __emit

// Computed properties and methods
const inspectors = computed((): Inspector[] => store.getters['diary/inspectorlist']);

const addBooking = (booking: Booking): Promise<Booking> => {
  return store.dispatch('diary/addBooking', booking);
};

const shareBooking = (payload: { booking: Booking, idlist: string[] }): Promise<Booking> => {
  return store.dispatch('diary/shareBooking', payload);
};

const saveBooking = (booking: Booking): Promise<Booking> => {
  return store.dispatch('diary/saveBooking', booking);
};

const insertBooking = (booking: Booking) => {
  store.commit('diary/insertBooking', booking);
};

const removeBooking = (id: string) => {
  store.commit('diary/removeBooking', id);
};


const inspectorlistinstring = computed(() => {
  return inspectors.value
    .sort((i1, i2) => i1.name.toLowerCase().localeCompare(i2.name.toLowerCase()))
    .filter(i => !i.inactive && i.name.toLowerCase() != "default" && (!inspectorinstringsearchfilter.value || i.name.toLowerCase().startsWith(inspectorinstringsearchfilter.value.toLowerCase())))
    .map(i => i.name);
});

// Converted methods (demonstrating a few)
const init = () => {
  personalbooking.value = new Booking();
  title.value = '';
  location.value = '';
  description.value = '';
  personalbooking.value.subbookings = [];
  selectedinspector.value = new Inspector();
  selectedinspectors.value = [];
  isSaving.value = false;
};

const add = () => {
  operation.value = "add";
  sharewithall.value = false;
  allday.value = false;
  personalbooking.value.allDay = false;
  personalbooking.value.startdate = moment().utc().format(bookingdateformat);
  personalbooking.value.enddate = moment().utc().format(bookingdateformat);
  personalbooking.value.auditlogs = [];
  personalbooking.value.subtype = Booking.PERSONAL;
  subjobdate.value = _currentdate.value;
  repeat.value = personalbooking.value.repeat;
  parserrule(personalbooking.value.recurrenceRule);
};

const addwith = (bookingData: Booking) => {
  operation.value = "add";
  allday.value = false;
  sharewithall.value = false;
  personalbooking.value = new Booking();
  personalbooking.value = new Booking(bookingData);
  personalbooking.value.subbookings = [];
  selectedinspector.value = new Inspector();
  personalbooking.value.subtype = Booking.PERSONAL;
  subjobdate.value = _currentdate.value;
  selectedinspector.value = bookingData.inspector;
  repeat.value = personalbooking.value.repeat;
  parserrule(personalbooking.value.recurrenceRule);
  isSaving.value = false;
};

const edit = () => {
  operation.value = "edit";
  sharewithall.value = false;
  personalbooking.value = new Booking(props.booking);
  bookingcopy.value = new Booking(props.booking);
  allday.value = personalbooking.value.allDay;
  subjobdate.value = personalbooking.value.startdateAsDate;
  selectedinspector.value = personalbooking.value.inspector;
  repeat.value = personalbooking.value.repeat;
  parserrule(personalbooking.value.recurrenceRule);
}


const restore = async () => {
  try {
    await store.dispatch('diary/restoreBooking', props.booking);
    toasted.success("Booking restored");
    emitEvent("appointmentRestoredInBookingTemplate", props.booking);
  } catch (err: any) {
    actProperty.displayError(err);
  }
};

// Other methods would be converted similarly...

onMounted(async () => {
  Promise.all([setStartTimeOptions(), setEndTimeOptions()])
    .then((values) => { })
    .catch((err) => {
      actProperty.displayError(err);
    });
});

const starttimeoptions = ref<string[]>([]);
const endtimeoptions = ref<string[]>([]);
const appointmenttimeoptions = ref<string[]>([]);
const setStartTimeOptions = () => {
  starttimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    starttimeoptions.value.push(hourMinutes);
    appointmenttimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
  }
}

const setEndTimeOptions = () => {
  endtimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  if (_startdate.value) {
    startmoment = moment(_startdate.value, "hh:mm A");
    startmoment.add(15, "minutes");
  }
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    endtimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
    if (hourMinutes === "09:00 PM ") break;
  }
}

const _startdate = computed({
  get: () => {
    let value = personalbooking.value.startdate
      ? moment(personalbooking.value.startdate).utc().format("hh:mm A")
      : "";
    const index = starttimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    personalbooking.value.startdate = subjobendDate(
      val,
      personalbooking.value.startdateAsDate
    );
    determinEnddate();
    determineAppointmenttime();
  }
});

const _enddate = computed({
  get: () => {
    let value = personalbooking.value.enddate
      ? moment(personalbooking.value.enddate).utc().format("hh:mm A")
      : "";
    const index = endtimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    personalbooking.value.enddate = subjobendDate(
      val,
      personalbooking.value.startdateAsDate
    );
    let duration = personalbooking.value.duration;
    if (duration === personalbooking.value.recommendedtime) duration = 0;
    personalbooking.value.preferredduration = duration;
    determineAppointmenttime();
  }
});

watch(() => _startdate.value, (newValue) => {
  setEndTimeOptions();
});

const inspector = computed({
  get: () => {
    const insp = inspectors.value.find(i => i.id === selectedinspector.value.id);
    return insp?.name ?? '';
  },
  set: (val: string) => {
    if (val) {
      const insp = inspectors.value.find(i => i.name === val);
      if (insp) {
        selectedinspector.value = insp;
      }
    }
  }
});

const dropDownOpened = (ref: string) => {
  nextTick(() => {
    // Get the reference to the dropdown list container
    const multiselect = dynamicRefs.value[ref] as any;
    const dropdownList = multiselect.$el.querySelector('.multiselect__content-wrapper');

    // Get the reference to the selected option element
    const selectedOption = multiselect.$el.querySelector('.multiselect__option--selected');

    // Scroll to the position of the selected element
    if (selectedOption?.offsetTop)
      dropdownList.scrollTop = selectedOption.offsetTop;
  });
}

const resetInspector = () => {
  selectedinspector.value = new Inspector();
};

const subjobendDate = (time: string, date: Date) => {
  let value = "";
  if (time) {
    let dt: Date = date ? date : _currentdate.value;
    let justdate = moment(dt).utc().format("YYYY-MM-DD");
    let justtime = moment(time, "hh:mm A").format("HH:mm");
    value = `${justdate}T${justtime}:00.000Z`;
  }
  return value;
}

const determinEnddate = () => {
  if (personalbooking.value.startdate && personalbooking.value.recommendedtime) {
    let time =
      props.booking.preferredduration > 0
        ? props.booking.preferredduration
        : personalbooking.value.recommendedtime;
    personalbooking.value.enddate = subjobendDate(
      moment(personalbooking.value.startdate)
        .utc()
        .add(time, "minutes")
        .format("hh:mm A"),
      personalbooking.value.startdateAsDate
    );
  }
}

const determineAppointmenttime = () => {
  let appointmenttime = "";
  let timeinminutes = 0;
  if (props.booking.preferredappointmenttime > 0)
    timeinminutes = props.booking.preferredappointmenttime;
  else if (personalbooking.value.recommendedappointmenttime > 0)
    timeinminutes = personalbooking.value.recommendedappointmenttime;

  // Round it to the nearest 15 minutes interval
  timeinminutes = Math.round(timeinminutes / 15) * 15;
  if (personalbooking.value.enddate && timeinminutes > 0) {
    appointmenttime = moment(personalbooking.value.enddate)
      .utc()
      .subtract(timeinminutes, "minutes")
      .format("hh:mm A");
  } else if (personalbooking.value.startdate) {
    appointmenttime = moment(personalbooking.value.startdate)
      .utc()
      .format("hh:mm A");
  }
  personalbooking.value.appointmenttime = subjobendDate(
    appointmenttime,
    personalbooking.value.startdateAsDate
  );
}



const setDescription = (val: string) => {
  personalbooking.value.description = val;
}

const description = computed({
  get: () => {
    return personalbooking.value.description;
    //if (personalbooking.value.pinotes)
    //  val = val ? `${val}\n${personalbooking.value.pinotes}` : personalbooking.value.pinotes;
    //return val;
  },
  set: (val: string) => {
    personalbooking.value.description = val;
  }
});

const title = computed({
  get: () => personalbooking.value.summary,
  set: (val: string) => {
    personalbooking.value.summary = val;
  }
});

const location = computed({
  get: () => personalbooking.value.location,
  set: (val: string) => {
    personalbooking.value.location = val;
  }
});

const repeat = computed({
  get: () => personalbooking.value.repeat,
  set: (val: string) => {
    personalbooking.value.repeat = val;
    if(val === 'Custom') {
      ends.value = '';
      repeatevery.value = 1;
      if (repeatevery.value > 1) {
        selectedfrequency.value =  `${repeatfrequency.value}s`;
      }
      else {
        selectedfrequency.value = repeatfrequency.value;
      }
      endson.value = threemonthsinfuture;
      endsafteroccurancenumber.value = 13;
      repeaton.value = [false,false,false,false,false,false,false]
    }
  }
});

const repeatoptions = computed((): string[] => {
  const options = [];
  options.push(`Doesn't repeat`);
  const sdmoment = moment(subjobdate.value)
  const weekday = sdmoment.format('dddd');
  const monthday = sdmoment.format('MMMM D');
  options.push(`Weekly on ${weekday}`);
  options.push(`Annually on ${monthday}`);
  options.push(`Custom`);
  return options;
})

const savingAllowed = computed(() => {
  let result = true;
  if (!selectedinspector.value || !selectedinspector.value.id || !subjobdate.value || !title.value)
    result = false;
  if (!allday.value && (!_startdate.value || !_enddate.value))
    result = false;
  return result;
});

const save = async () => {
  hide();
  if (operation.value === "edit") {
    if (personalbooking.value.repeat !== "Doesn't repeat" && personalbooking.value.recurrenceRule) {
      const modal = recursionConfirmModal.value as any;
      modal.init(personalbooking.value);
      modal.edit();
      modal.show();
    } else {
      selectEditNoteModal('blank', personalbooking.value);
    }
  } else {
    selectEditNoteModal('blank', personalbooking.value);
  }
};

const selectEditNoteModal = async (val: any, book: Booking) => {
  if (selectedinspector.value.id) {
    isSaving.value = true;
    personalbooking.value.recurrenceRule = formatrrule();
    personalbooking.value.jobtype = Booking.PERSONAL;
    personalbooking.value.subtype = Booking.PERSONAL;
    personalbooking.value.allDay = allday.value;
    if (operation.value === "add") {
      personalbooking.value.id = "";
      personalbooking.value.inspector = selectedinspector.value;
      if (personalbooking.value.allDay) {
        const startTime = "T09:00:00.000Z";
        const endTime = "T18:00:00.000Z";
        personalbooking.value.startdate = subjobendDate(
          startTime,
          subjobdate.value
        );
        personalbooking.value.appointmenttime = subjobendDate(
          startTime,
          subjobdate.value
        );
        personalbooking.value.enddate = subjobendDate(
          endTime,
          subjobdate.value
        );
      } else {
        personalbooking.value.startdate = subjobendDate(
          personalbooking.value.starttime,
          subjobdate.value
        );
        personalbooking.value.enddate = subjobendDate(
          personalbooking.value.endtime,
          subjobdate.value
        );
      }

      addBooking(personalbooking.value)
        .then(async (b: Booking) => {
          channel.publish('newAppointmentAdded', { deviceid: deviceid, bookingid: b.id });
          return b;
        })
        .then((newbooking: Booking) => {
          var sharelist: Inspector[] = [];
          if (sharewithall.value) {
            sharelist = [...inspectors.value];
          }
          else if (selectedinspectors.value?.length) {
            sharelist = [...selectedinspectors.value];
          }
          const idlist: string[] = sharelist.filter((i) => i.id != personalbooking.value.inspector.id).map((i) => i.id);
          if (idlist.length) {
            shareBooking({ booking: personalbooking.value, idlist })
              .then((bookingidlist) => {
                channel.publish('newAppointmentsAdded', { deviceid: deviceid, bookingid: newbooking.id, bookingidlist: bookingidlist });
              });
          }

        })
        .catch((err: any) => {
          isSaving.value = false;
          actProperty.displayError(err);
        });
    } else {
      hiderecusionmodel();
      personalbooking.value.inspector = selectedinspector.value;
      if (personalbooking.value.allDay) {
        const startTime = "T09:00:00.000Z";
        const endTime = "T18:00:00.000Z";
        personalbooking.value.startdate = subjobendDate(
          startTime,
          subjobdate.value
        );
        personalbooking.value.appointmenttime = subjobendDate(
          startTime,
          subjobdate.value
        );
        personalbooking.value.enddate = subjobendDate(
          endTime,
          subjobdate.value
        );
      } else {
        personalbooking.value.startdate = subjobendDate(
          personalbooking.value.starttime,
          subjobdate.value
        );
        personalbooking.value.enddate = subjobendDate(
          personalbooking.value.endtime,
          subjobdate.value
        );
      }
      if (props.booking.googleid) {
        personalbooking.value.description = description.value;
      }
      if (val === 'thisevent') {
        bookingcopy.value.addExclDate(_currentdate.value);
        saveBooking(bookingcopy.value)
          .then((savednpb: Booking) => {
            // Remove current booking from the list
            removeBooking(savednpb.id);
            // Now save the new changes as a single entry personal booking
            personalbooking.value.id = '';
            personalbooking.value.startdate = actProperty.prependDate(
              moment(personalbooking.value.startdate).utc().format("hh:mm A"),
              _currentdate.value,
              _currentdate.value
            );
            personalbooking.value.enddate = actProperty.prependDate(
              moment(personalbooking.value.enddate).utc().format("hh:mm A"),
              _currentdate.value,
              _currentdate.value
            );
            personalbooking.value.repeat = `Doesn't repeat`;
            personalbooking.value.recurrenceRule = '';
            personalbooking.value.recurrenceExclDates = '';
            addBooking(personalbooking.value)
              .then((newbooking) => {
                insertBooking(newbooking);
                toasted.success("Booking saved");
              });
          }).catch((err: any) => {
            actProperty.displayError(err);
          });
      } else if (val === 'thisandfollowingevent') {
        const datebeforecurrentdate = moment(_currentdate.value).utc().subtract(1, 'day').endOf('day').toDate();
        bookingcopy.value.setRecurrenceEnddate(datebeforecurrentdate);
        saveBooking(bookingcopy.value)
          .then((savednpb: Booking) => {
            // Reaload current booking
            removeBooking(savednpb.id);
            // Now save the new changes as a single entry personal booking
            personalbooking.value.id = '';
            personalbooking.value.startdate = actProperty.prependDate(
              moment(personalbooking.value.startdate).utc().format("hh:mm A"),
              _currentdate.value,
              _currentdate.value
            );
            personalbooking.value.enddate = actProperty.prependDate(
              moment(personalbooking.value.enddate).utc().format("hh:mm A"),
              _currentdate.value,
              _currentdate.value
            );
            addBooking(personalbooking.value)
              .then((newbooking) => {
                insertBooking(newbooking);
                toasted.success("Booking saved");
              });
          });
      } else {
        await saveBooking(personalbooking.value)
          .then(() => {
            isSaving.value = false;
            //if (val != 'allevents') {
            channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: personalbooking.value.id, source: 'Scheduler' });
            //}
          })
          .then(() => {
            //https://trello.com/c/jNVjqmVi/564-new-note-booking
            if (selectedinspectors.value?.length) {
              selectedinspectors.value.forEach((i: Inspector) => {
                const copybooking = new Booking(personalbooking.value);
                copybooking.inspector = i;
                addBooking(copybooking).
                  then((cb: Booking) => {
                    hiderecusionmodel();
                    channel.publish('newAppointmentAdded', { deviceid: deviceid, bookingid: cb.id });
                  })
              })
            }
          })
          .catch((err: any) => {
            hiderecusionmodel();
            isSaving.value = false;
            actProperty.displayError(err);
          });
      }
    }
  }
}

const hiderecusionmodel = () => {
  const modal = recursionConfirmModal.value as any;
  modal.hide();
}

const formatrrule = () => {
  const rruleSet = new RRuleSet()
  const sdmoment = moment(subjobdate.value)
  const weekday = sdmoment.format('dddd');
  var weekd = RRule.MO;
  switch (weekday) {
    case 'Monday': weekd = RRule.MO; break;
    case 'Tuesday': weekd = RRule.TU; break;
    case 'Wednesday': weekd = RRule.WE; break;
    case 'Thursday': weekd = RRule.TH; break;
    case 'Friday': weekd = RRule.FR; break;
    case 'Saturday': weekd = RRule.SA; break;
    case 'Sunday': weekd = RRule.SU; break;
  }
  if (repeat?.value === '' || repeat.value === `Doesn't repeat`) {
    return '';
  }
  else if (repeat.value.startsWith(`Weekly`)) {
    const rrule = new RRule({
      freq: RRule.WEEKLY,
      interval: 1,
      byweekday: weekd,
      dtstart: subjobdate.value,
    });
    rruleSet.rrule(rrule);
    return rruleSet.toString();
  }
  else if (repeat.value.startsWith(`Annually`)) {
    const rrule = new RRule({
      freq: RRule.YEARLY,
      interval: 1,
      dtstart: subjobdate.value,
    });
    rruleSet.rrule(rrule);
    return rruleSet.toString();
  }

  var frequency = RRule.DAILY;
  if (repeatfrequency.value === 'week') frequency = RRule.WEEKLY;
  else if (repeatfrequency.value === 'month') frequency = RRule.MONTHLY;
  else if (repeatfrequency.value === 'year') frequency = RRule.YEARLY;
  var byweekday = [];
  for (var i = 0; i < repeaton.value.length; i++) {
    if (repeaton.value[i]) {
      switch (i) {
        case 0: byweekday.push(RRule.MO); break;
        case 1: byweekday.push(RRule.TU); break;
        case 2: byweekday.push(RRule.WE); break;
        case 3: byweekday.push(RRule.TH); break;
        case 4: byweekday.push(RRule.FR); break;
        case 5: byweekday.push(RRule.SA); break;
        case 6: byweekday.push(RRule.SU); break;
      }
    }
  }

  const options = {
    freq: frequency,
    interval: repeatevery.value,
    byweekday: byweekday,
    dtstart: subjobdate.value,
  }
  if (ends.value === 'After') {
    options['count'] = endsafteroccurancenumber.value;
  }
  else if (ends.value === 'On') {
    options['until'] = endson.value;
  }

  rruleSet.rrule(new RRule(options));
  return extractRRule(rruleSet.toString());
}

const extractRRule = (val: string) => {
  let rruleOnly = val;
  rruleOnly = val
    .split("\n")
    .find((line) => line.startsWith("RRULE"));
  return rruleOnly;
}

const parserrule = (val: string) => {
  if (!val) return;
  const options = RRuleSet.parseString(val);

  repeatevery.value = options.interval;
  switch (options.freq) {
    case RRule.DAILY: repeatfrequency.value = 'day'; break;
    case RRule.WEEKLY: repeatfrequency.value = 'week'; break;
    case RRule.MONTHLY: repeatfrequency.value = 'month'; break;
  }

  repeaton.value = [false, false, false, false, false, false, false];
  if (options.byweekday && Array.isArray(options.byweekday)) {
    for (var i = 0; i < options.byweekday.length; i++) {
      const bwd = options.byweekday[i];
      switch (bwd) {
        case RRule.MO: repeaton.value[0] = true; break;
        case RRule.TU: repeaton.value[1] = true; break;
        case RRule.WE: repeaton.value[2] = true; break;
        case RRule.TH: repeaton.value[3] = true; break;
        case RRule.FR: repeaton.value[4] = true; break;
        case RRule.SA: repeaton.value[5] = true; break;
        case RRule.SU: repeaton.value[6] = true; break;
      }
    }
  }

  if (options.count > 0) {
    ends.value = 'After';
    endsafteroccurancenumber.value = options.count;
  }
  else if (options.until) {
    ends.value = 'On';
    endson.value = options.until;
  }

  if (!repeat.value) {
    repeat.value = 'Custom';
  }
}

const filteredsortedinspectorlist = computed(() => {
  return inspectorlist.value
    .filter((i: Inspector) => i.name.toLowerCase() != "default" && i.name != inspector.value)
    .sort((insp1: Inspector, insp2: Inspector) => {
      let val: number = insp1.region.localeCompare(insp2.region);
      if (val === 0) val = insp1.name.localeCompare(insp2.name);
      return val;
    });
});

const inspectoroptions = computed((): Inspector[] => {
  filteredsortedinspectorlist.value
    .sort((i1, i2) => i1.name.toLowerCase().localeCompare(i2.name.toLowerCase()))
    .filter(i => i.name.toLowerCase() != "default" && (!copytoinspectorinstringsearchfilter.value || i.name.toLowerCase().startsWith(copytoinspectorinstringsearchfilter.value.toLowerCase())))
    .map(i => i.name);
  return [...filteredsortedinspectorlist.value];
});


const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};


const isNumber = (event: any) => {
  const keyCode = event.keyCode || event.which;
  const inputChar = String.fromCharCode(keyCode);
  if (!/^[1-9]\d*$/.test(event.target.value + inputChar)) {
    event.preventDefault();
  }
}

__expose({ init, add, addwith, edit, show, hide })

const customLabel = (option: string) => {
  return option.replace(/^0/, '');
}


return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal",
      "data-keyboard": "true",
      tabindex: "-1",
      role: "dialog",
      id: __props.id,
      "aria-labelledby": "`personal-job-modal-label`",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'modal-lg': repeat.value === 'Custom' }]),
        role: "document"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              (operation.value === 'add')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Add personal event"))
                : _createCommentVNode("", true),
              (operation.value === 'edit')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Edit personal event"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              id: "close",
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
            }, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-6", { 'col-md-6': repeat.value === 'Custom', 'col-md-12': repeat.value != 'Custom' }])
              }, [
                _createElementVNode("form", null, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event))
                        }, null, 512), [
                          [_vModelText, title.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(DxDateBox), {
                          modelValue: subjobdate.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subjobdate).value = $event)),
                          "display-format": "dd/MM/yyyy",
                          type: "date",
                          "picker-type": "calendar",
                          "apply-value-mode": "instantly",
                          calendarOptions: { firstDayOfWeek: 1 }
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_singleselect_text, {
                          modelValue: inspector.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inspector).value = $event)),
                          options: inspectorlistinstring.value,
                          "allow-empty": true,
                          taggable: false,
                          onSearchChange: _cache[4] || (_cache[4] = ($event: any) => (inspectorinstringsearchfilter.value = $event)),
                          ref: el => { dynamicRefs.value['inspectorDropDown'] = el },
                          onOpen: _cache[5] || (_cache[5] = ($event: any) => (dropDownOpened('inspectorDropDown')))
                        }, _createSlots({ _: 2 }, [
                          (selectedinspector.value && selectedinspector.value.id)
                            ? {
                                name: "clear",
                                fn: _withCtx(() => [
                                  _createElementVNode("i", {
                                    onMousedown: _withModifiers(resetInspector, ["prevent","stop"]),
                                    class: "multiselect__clear fa fa-times",
                                    "aria-label": "Clear Who"
                                  }, null, 32)
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["modelValue", "options"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'col-md-6': operation.value === 'add', 'col-md-8': operation.value === 'edit' })
                      }, [
                        _createVNode(_component_multiselect_text, {
                          class: "inspectorfilter",
                          modelValue: selectedinspectors.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedinspectors).value = $event)),
                          options: inspectoroptions.value,
                          "allow-empty": true,
                          taggable: false,
                          disabled: sharewithall.value,
                          onSearchChange: _cache[7] || (_cache[7] = ($event: any) => (copytoinspectorinstringsearchfilter.value = $event)),
                          placeholder: "Select",
                          trackBy: "id",
                          label: "name",
                          multiple: ""
                        }, null, 8, ["modelValue", "options", "disabled"])
                      ], 2),
                      (operation.value === 'add')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_22, "All"))
                        : _createCommentVNode("", true),
                      (operation.value === 'add')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(_unref(DxSwitch), {
                              value: sharewithall.value,
                              onValueChanged: _cache[8] || (_cache[8] = ($event: any) => (sharewithall.value = $event.value))
                            }, null, 8, ["value"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (!allday.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_singleselect_text, {
                              modelValue: _startdate.value,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_startdate).value = $event)),
                              options: starttimeoptions.value,
                              customLabel: customLabel,
                              "allow-empty": true,
                              taggable: false,
                              ref: el => { dynamicRefs.value['startDateDropDown'] = el },
                              onOpen: _cache[11] || (_cache[11] = ($event: any) => (dropDownOpened('startDateDropDown')))
                            }, _createSlots({ _: 2 }, [
                              (_startdate.value)
                                ? {
                                    name: "clear",
                                    fn: _withCtx(() => [
                                      _createElementVNode("i", {
                                        onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_startdate.value = ''), ["prevent","stop"])),
                                        class: "multiselect__clear fa fa-times",
                                        "aria-label": "Clear Start Time"
                                      }, null, 32)
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_singleselect_text, {
                              modelValue: _enddate.value,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_enddate).value = $event)),
                              options: endtimeoptions.value,
                              customLabel: customLabel,
                              "allow-empty": true,
                              taggable: false,
                              ref: el => { dynamicRefs.value['endDateDropDown'] = el },
                              onOpen: _cache[14] || (_cache[14] = ($event: any) => (dropDownOpened('endDateDropDown')))
                            }, _createSlots({ _: 2 }, [
                              (_enddate.value)
                                ? {
                                    name: "clear",
                                    fn: _withCtx(() => [
                                      _createElementVNode("i", {
                                        onMousedown: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_enddate.value = ''), ["prevent","stop"])),
                                        class: "multiselect__clear fa fa-times",
                                        "aria-label": "Clear End Time"
                                      }, null, 32)
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["modelValue", "options"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_unref(DxSwitch), {
                          value: allday.value,
                          onValueChanged: _cache[15] || (_cache[15] = ($event: any) => (allday.value = $event.value))
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          rows: "3",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((location).value = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            location.value,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    (__props.booking.googleid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (_openBlock(), _createBlock(TiptapEditor, {
                            key: personalbooking.value.id,
                            content: description.value,
                            onBlur: setDescription
                          }, null, 8, ["content"]))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control description-textarea",
                              rows: "6",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((description).value = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                description.value,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ])),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_singleselect_text, {
                          modelValue: repeat.value,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((repeat).value = $event)),
                          options: repeatoptions.value
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ])
                ])
              ], 2),
              (repeat.value === 'Custom')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("form", null, [
                      _createElementVNode("fieldset", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control",
                                  style: {"height":"40px"},
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((repeatevery).value = $event)),
                                  min: "1",
                                  onKeypress: _cache[20] || (_cache[20] = ($event: any) => (isNumber($event)))
                                }, null, 544), [
                                  [_vModelText, repeatevery.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_singleselect_text, {
                                  modelValue: selectedfrequency.value,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((selectedfrequency).value = $event)),
                                  options: repeatfrequencyoptions.value
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(repeatonoptions, (letter, $index) => {
                              return _createElementVNode("button", {
                                key: $index,
                                type: "button",
                                class: _normalizeClass(["btn alphabet-button", { 'btn-primary': repeaton.value[$index] }]),
                                onClick: ($event: any) => (repeaton.value[$index] = !repeaton.value[$index])
                              }, _toDisplayString(letter), 11, _hoisted_51)
                            }), 64))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_singleselect_text, {
                              modelValue: ends.value,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((ends).value = $event)),
                              options: endsonoptions
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        (ends.value === 'On')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("div", _hoisted_57, [
                                _createVNode(_unref(DxDateBox), {
                                  modelValue: endson.value,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((endson).value = $event)),
                                  "display-format": "dd/MM/yyyy",
                                  type: "date",
                                  "picker-type": "calendar",
                                  "apply-value-mode": "instantly",
                                  calendarOptions: { firstDayOfWeek: 1 }
                                }, null, 8, ["modelValue"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (ends.value === 'After')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _hoisted_59,
                              _createElementVNode("div", _hoisted_60, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control",
                                  style: {"height":"40px"},
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((endsafteroccurancenumber).value = $event))
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    endsafteroccurancenumber.value,
                                    void 0,
                                    { lazy: true }
                                  ]
                                ]),
                                _createTextVNode(" Occurance ")
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            (operation.value === 'edit' && __props.booking.cancelled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline-secondary mr-auto",
                  "data-dismiss": "modal",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (restore()), ["prevent"]))
                }, " Restore "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-dismiss": "modal",
              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (hide()), ["prevent"]))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-dismiss": "modal",
              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (save()), ["prevent"])),
              disabled: isSaving.value || !savingAllowed.value
            }, " Save ", 8, _hoisted_62)
          ])
        ])
      ], 2)
    ], 8, _hoisted_1),
    _createVNode(_unref(RecursionConfirmModal), {
      id: "edit-note-model",
      ref_key: "recursionConfirmModal",
      ref: recursionConfirmModal,
      booking: __props.booking,
      onSelect: selectEditNoteModal
    }, null, 8, ["booking"])
  ], 64))
}
}

})